import { paddingMinusBorder } from '../utils/tailwind/paddingMinusBorder';
import type { TextInputSize } from './TextInput.types';

export const textInputPaddingClassName: { [Key in TextInputSize]: string } = {
  small: paddingMinusBorder['2xs'],
  default: paddingMinusBorder['2xs'],
  large: paddingMinusBorder.xs,
};
